// eslint-disable-next-line
export const questionDialogFormInitial = {
  id: null,
  title: null,
  categoryId: null,
  questionType: null,
  isRequired: true,
  isProfile: false,
  isGlobal: false,
  profileField: null,
  chart: 'VERTICAL_BAR',
  insight:
    'As many as {positive_percentage} of respondents are positive about buying in this category',
  choices: [],
};

export const choiceTemplateDialogFormInitial = {
  title: null,
  description: null,
  categoryId: null,
  isGlobal: false,
  keywords: [],
};

export const hookDialogFormInitial = {
  id: null,
  title: null,
  artist: null,
  description: null,
  fileData: null,
  file: null,
};

export const matrixChoiceDialogFormInitial = {
  id: null,
  name: null,
  title: null,
  visibleIf: null,
  isRequired: null,
  choices: [],
};



// WEBPACK FOOTER //
// ./src/store/modules/surveybuilder/initial-state.js